module.exports = __webpack_public_path__ + "e45541d7d59ca56992f19e4ed925ed72.MP3";